module.exports = __webpack_public_path__ + "static/img/wavm8s-017-otang.7e6aa2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-017-otang.png
// module id = dO/d
// module chunks = 0